const LoaderText = ({ text = 'Loading', size = 'md', color = 'blue' }) => {
    const sizeClasses = {
        sm: 'text-sm',
        md: 'text-lg',
        lg: 'text-xl',
    };

    const colorClasses = {
        blue: 'text-blue-600',
        gray: 'text-gray-600',
        green: 'text-green-600',
        purple: 'text-purple-600',
        white: 'text-white',
    };

    return (
        <div className="flex items-center justify-center">
            <div className={`font-medium ${sizeClasses[size]} ${colorClasses[color]} flex items-center`}>
                <span>{text}</span>
                <span className="inline-flex ml-1">
                    <span
                        className="animate-pulse"
                        style={{
                            animation: 'dot1 1.5s infinite',
                        }}
                    >
                        .
                    </span>
                    <span
                        className="animate-pulse"
                        style={{
                            animation: 'dot2 1.5s infinite',
                        }}
                    >
                        .
                    </span>
                    <span
                        className="animate-pulse"
                        style={{
                            animation: 'dot3 1.5s infinite',
                        }}
                    >
                        .
                    </span>
                </span>
            </div>

            <style jsx>{`
                @keyframes dot1 {
                    0%,
                    20% {
                        opacity: 0;
                    }
                    25%,
                    100% {
                        opacity: 1;
                    }
                }

                @keyframes dot2 {
                    0%,
                    40% {
                        opacity: 0;
                    }
                    45%,
                    100% {
                        opacity: 1;
                    }
                }

                @keyframes dot3 {
                    0%,
                    60% {
                        opacity: 0;
                    }
                    65%,
                    100% {
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
};

export default LoaderText;
